import { Component, OnInit } from '@angular/core';
import {FoEventsService} from "../event/foevents.service";
import {ActivatedRoute} from "@angular/router";
import {FonctionUtiles} from "../fonctionsUtiles";
import {BooKingservice} from "../booking/booking.service";

@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

  links:any = [];
  constructor(private bookingservice: BooKingservice,private eventservice: FoEventsService,private route: ActivatedRoute,public functionUtils: FonctionUtiles ) { }

  ngOnInit() {
    this.bookingservice.store('embededMode',true);
    this.loadLinks();
  }

  loadLinks(){
    let c = new Date();
    this.eventservice.getAkcesLinks(c.getTime()).then(res => {
      this.links = res;
    })
  }

  cutEventname(name) {
    if(name.length<40)
      return name;
    else
      return name.slice(0,40);
  }

  eventImage(event) {

    if(event.thumbnail)
      return event.thumbnail;
    else
      return event.image;
  }

  slugify(name){
    return this.functionUtils.slugify(name)
  }

  cropEventName(str) {
    if(window.screen.width < 365)
      return str.substring(0, 10);
    else
      return str;
  }

}
